/**
 * Ticket: SL-664
 * JIRA - https://toolsvilla.atlassian.net/browse/SL-664
 * Description - Quarterly report shows you TDS Certificate
 * Author - Ankit Nigam
 */
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import api from "../../seller-apis/api";
import "../../assets/css/quarterlyReport.css";
import MainLoader from "../common/Loader/PageLoader";
const QuarterlyReport = () => {
  var outerdiv;
  var loaderDiv;

  const [data, setData] = useState([]);
  

  // Loader
  const [ennewloader, setennewloader] = useState("block");

   //Year Dropdown
   const [year, setYear] = useState(new Date().getFullYear()); // Default to current year
   const minYear = 2022; // Set your minimum year here
   const maxYear = new Date().getFullYear(); // Set maximum year to current year
   // Generate an array of years
   const years = [];
   for (let fy = minYear; fy <= maxYear; fy++) {
    const nextYear = (parseInt(fy, 10) + 1).toString();
    const financialYear = `${fy}-${nextYear.slice(-2)}`;
    years.push({value:fy,label:financialYear});
   }
  const nextYear = (parseInt(year, 10) + 1).toString();
  const [showYear, setShowYear] = useState(`${year}-${nextYear.slice(-2)}`); // To display the financial year
  
  useEffect(() => {
   

    applyLoader();

    api.vendorledger
      .getVendorTDSReportByYear({
        filter: {
          "year": year.toString()
          
        },
        excludeField: {},
        pageNo: 1,
        size: 10,
        sortFilter: {
          tdsMonthDate: -1,
        },
      })
      .then((res) => {
        setData(res.data);
        removeLoader();
      })
      .catch((err) => console.log(err));
  }, []);

  /**
   * Handle the Year Change
   * @param {*} e 
   */
  function handleYearChange(selectedYear) {
    setYear(selectedYear);
    const nextYear = (parseInt(selectedYear, 10) + 1).toString();
    const financialYear = `${selectedYear}-${nextYear.slice(-2)}`;
    setShowYear(financialYear);
  

    applyLoader();
    api.vendorledger
        .getVendorTDSReportByYear({
          filter: {
            "year": selectedYear.toString()
          },
          excludeField: {},
          pageNo: 1,
          size: 10,
          sortFilter: {
            tdsMonthDate: -1,
          },
        })
        .then((res) => {
          setData(res.data);
          removeLoader();
        })
        .catch((err) => console.log(err));
   
  }


  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("payment_tab");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none");
    outerdiv.classList.remove("div-bk");
  }

  // l1-2977
  const downloadFile = (file, docNo, type) => {
    let lastDot = file.lastIndexOf(".");
    let fileType = file.substr(lastDot);
    let downloadName = docNo + "-" + type;
    let data = {
      "bucket": "seller_doc",
      "key": file
    }
    api.docs.getImage(data).then((res) => {
      const fileUrl = res.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", downloadName + fileType);
      document.body.appendChild(link);
      link.target = "_blank";
      link.click();
      document.body.removeChild(link);
    }).catch(err => console.log(err))
  }

  /**
   * Render Method
   */
  return (
    <div id="orDeskContain" className="mb-4 mx-2">
      {/* New orders desktop */}
      <div className="tab">
        <div className="contain_payment_table mx-2">
          <div className="d-flex mb-3 justify-content-end">
            <div className="theme-shed1 p-2">
              <div className="m-auto mt-1">
                <span className="payment_dates">
                  Select Financial Year: -{" "}
                  <select
                    key={year}
                    id="year"
                    value={year}
                    onChange={(e) => handleYearChange(e.target.value)}
                  >
                    {years.map((yr) => (
                      <option key={yr.value} value={yr.value}>
                        {yr.label}
                      </option>
                    ))}
                  </select>
               
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
        <table
          className="payment_table"
          style={{ width: "100%" }}
          id="payment_tab"
        >
          <thead>
            <tr className="quarterly_report_tr">
              <th className="thead_title " style={{ width: "30%" }}>
                Financial Year
              </th>

              <th className="thead_title" style={{ width: "30%" }}>
                Quarter
              </th>

              <th className="thead_title" style={{ width: "30%" }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
         
             {/* Q4 */}
            <tr key={"Q4"} className="quarterly_report_tr">
              <td>{showYear == undefined ? <></> : showYear}</td>
              <td key={"Q4"}>Q4</td>
              <td>
              {data && (
                (() => {
                  const item = data.find((item) => item.quater === "Q4");
                  if (item && item.status == "Uploaded") {
                    return (
                      <>
                        Download Report{" "}
                        <span
                         onClick={()=>downloadFile(item.tdsCertificate, "TDS_Certificate_" + showYear, "pdf")}
                         >
                            <i className="fa fa-download" aria-hidden="true"></i>
                        </span>
                      </>
                    );
                  } else if(item && item.status == "NA"){
                    return <>Not Applicable</>;
                  } else {
                    return <>Report not generated</>;
                  }
                })()
              )}
              </td>
            </tr>
            {/* Q3 */}
            <tr key={"Q3"} className="quarterly_report_tr">
              <td>{showYear == undefined ? <></> : showYear}</td>
              <td key={"Q3"}>Q3</td>
              <td>
              {data && (
                (() => {
                  const item = data.find((item) => item.quater === "Q3");
                  if (item && item.status == "Uploaded") {
                    return (
                      <>
                        Download Report{" "}
                        <span
                        onClick={()=> downloadFile(item.tdsCertificate, "TDS_Certificate_" + showYear, "pdf")}
                        >
                            <i className="fa fa-download" aria-hidden="true"></i>
                        </span>
                      </>
                    );
                  } else if(item && item.status == "NA"){
                    return <>Not Applicable</>;
                  } else {
                    return <>Report not generated</>;
                  }
                })()
              )}
              </td>
            </tr>
            {/* Q2 */}
            <tr key={"Q2"} className="quarterly_report_tr">
              <td>{showYear == undefined ? <></> : showYear}</td>
              <td key={"Q2"}>Q2</td>
              <td>
              {data && (
                (() => {
                  const item = data.find((item) => item.quater === "Q2");
                  if (item && item.status == "Uploaded") {
                    return (
                      <>
                        Download Report{" "}
                        <span
                        onClick={()=> downloadFile(item.tdsCertificate, "TDS_Certificate_" + showYear, "pdf")}
                        >
                            <i className="fa fa-download" aria-hidden="true"></i>
                        </span>
                      </>
                    );
                  } else if(item && item.status == "NA"){
                    return <>Not Applicable</>;
                  } else {
                    return <>Report not generated</>;
                  }
                })()
              )}
              </td>
            </tr>
            {/* Q1 */}
            <tr key={"Q1"} className="quarterly_report_tr">
              <td>{showYear == undefined ? <></> : showYear}</td>
              <td key={"Q1"}>Q1</td>
              <td>
              {data && (
                (() => {
                  const item = data.find((item) => item.quater === "Q1");
                  if (item && item.status == "Uploaded") {
                    return (
                      <>
                        Download Report{" "}
                        <span
                        onClick={()=> downloadFile(item.tdsCertificate, "TDS_Certificate_" + showYear, "pdf")}
                        >
                            <i className="fa fa-download" aria-hidden="true"></i>
                        </span>
                      </>
                    );
                  } else if(item && item.status == "NA"){
                    return <>Not Applicable</>;
                  } else {
                    return <>Report not generated</>;
                  }
                })()
              )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>

      <div className="d-flex justify-content-center" id="enNewLoader">
        <div
          style={{ display: ennewloader }}
        >
          <MainLoader/>
        </div>
      </div>
    </div>
  );
};

export default QuarterlyReport;
